import RevxFlexLayout from 'components/RevxFlexLayout';
import { UOMCoefficientEnum } from 'domains/svcDomain';
import { cloneDeep } from 'lodash-es';
import { useEffect } from 'react';
import { ConfigSvcProps } from '..';
import CommonJobSvcBorder from '../common/CommonJobSvcBorder';
import CommonJobSvcCotainer from '../common/CommonJobSvcCotainer';
import CommonJobSvcInstructions from '../common/CommonJobSvcInstructions';
import CommonJobSvcMessage from '../common/CommonJobSvcMessage';
import CommonJobSvcName from '../common/CommonJobSvcName';
import CommonJobSvcOption from '../common/CommonJobSvcOption';
import CommonJobSvcSpec from '../common/CommonJobSvcSpec';
import { useHideSvc } from '../hook/useHideSvc';
import { useHideSvcContainer } from '../hook/useHideSvcContainer';

const Chipboard22pt = (props: ConfigSvcProps) => {
  const { formCache, form, id, jobOptionSvc } = props;
  const hideSvc = useHideSvc(props);
  const hideSvcContainer = useHideSvcContainer(props);

  useEffect(() => {
    if (!formCache?.[id]) {
      form.resetFields();
      form.setFieldsValue(formCache);
    }
    if (
      formCache?.[39]?.name?.includes('Padding Adhesive') &&
      formCache?.[40]?.name &&
      formCache[39].quantityPerBundle
    ) {
      const cloneFormCache = cloneDeep(formCache);
      cloneFormCache[40].quantityPerBundle = formCache[39].quantityPerBundle;
      form?.setFieldsValue(cloneFormCache);
    }
    // eslint-disable-next-line
  }, [formCache, form]);

  // const disabledQuantityPerBundle = useMemo(() => {
  //   return formCache?.[39]?.name?.includes('Padding Adhesive');
  // }, [formCache]);

  return (
    <>
      <div style={hideSvc}>
        <RevxFlexLayout align="top" justify="justify-start">
          <CommonJobSvcName {...props} />
          <div>
            <CommonJobSvcCotainer
              {...props}
              jobOptionSvc={{
                ...jobOptionSvc,
                uomCoefficient: UOMCoefficientEnum.ITEM_SQ_IN,
              }}
            >
              <CommonJobSvcSpec {...props} disabled={hideSvcContainer} />
              <CommonJobSvcOption {...props} disabled={hideSvcContainer} />
              {/* <CommonQuantityPerBundle
                {...props}
                title={'Amount per Pad'}
                show={true}
                disabled={disabledQuantityPerBundle}
              /> */}
              <CommonJobSvcInstructions
                {...props}
                disabled={hideSvcContainer}
              />
              <CommonJobSvcMessage {...props} disabled={hideSvcContainer} />
            </CommonJobSvcCotainer>
          </div>
        </RevxFlexLayout>
        <CommonJobSvcBorder />
      </div>
    </>
  );
};

export default Chipboard22pt;
